import React from 'react'
import { StyledFlexStart, StyledLeadContainer, StyledSubHeader } from './Styled'
import TextFiledWithLabel from './TextFieldWithLabel'
import { handleValidateCodevalue, templateParams } from '../Utility/constant'
import ReactQuill from 'react-quill'
import { useSelector } from 'react-redux'
import { Box, Button, IconButton, MenuItem } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';

const TemplateBody = ({isWhatsapp,paramsList,setParamsList,
  disabled=false, requiredError,templateBodyValue,handleQuillChange,handleAddParam,quillRef}) => {
    

    const modules = {
        toolbar: [
          [{ 'header': [1, 2, false] }],
          ['bold', 'italic',],
          [ {'list': 'bullet'}],
          ['link'],

        ],
      }
    
      const formats = [
        'header',
        'bold', 'italic',
        'list', 'bullet',
        'link'
      ]
    
    const whatsappModules = {
      toolbar: false,  
    };

    const whatsappFormats = []
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData)


const handleAddWhatsappParam = () => {
  const newIndex = paramsList.length + 1;
  const newParamKey = `{{${newIndex}}}`;

  setParamsList(prev => [
    ...prev,
    { key: newParamKey, value: "" }
  ]);
};

const handleRemoveWhatsappParam = (indexToRemove) => {
  const updatedParams = paramsList.filter((_, i) => i !== indexToRemove);

  const reIndexedParams = updatedParams.map((param, idx) => ({
    key: `{{${idx + 1}}}`,
    value: param.value
  }));

  setParamsList(reIndexedParams);
};

  return (
    <>
    
                <StyledFlexStart sx = {{gap : 3, alignItems: 'center'}}>
                    <StyledSubHeader>
                    {handleValidateCodevalue(internationalise,'TEMP_EDIT_BODY')}
                    </StyledSubHeader>
                      {isWhatsapp &&
          <StyledLeadContainer>
            <Button
              className='biztantu-sec-btn'
              variant="outlined"
              onClick={handleAddWhatsappParam}>
              {handleValidateCodevalue(internationalise,"TEMP_EDIT_ADD_PARAMS")}
            </Button>    
            </StyledLeadContainer>
          }
                    {!disabled &&
                    <Box sx={{ minWidth: 250 }}>
                      <TextFiledWithLabel
                          isStatic={true}
                          select
                          name="params"
                          value = {""}
                          label= {handleValidateCodevalue(internationalise,'TEMP_EDIT_ADD_PARAMS')}
                          handleOnChange={(e)=>handleAddParam(e?.target?.value)} 
                      >
                         {templateParams?.map(option=>
                         <MenuItem key={option?.value} value={option?.value}>
                          {handleValidateCodevalue(internationalise,option?.label)} -- {option?.value}
                          </MenuItem>
                         )}
                      </TextFiledWithLabel>
                    </Box>
                    }
                </StyledFlexStart>
          
               {isWhatsapp && paramsList.map((param, index) => (
                  <TextFiledWithLabel
                    sx={{ paddingRight: 2 }}
                    key={param.key}
                    label={`{{${index + 1}}}`}
                    value={param.value}
                    handleOnChange={(e) => {
                      const updated = [...paramsList];
                      updated[index].value = e.target.value;
                      setParamsList(updated);
                    }}
                    InputProps={{
                      endAdornment: (
                        <IconButton onClick={() => handleRemoveWhatsappParam(index)}>
                          <CloseIcon />
                        </IconButton>
                      ),
                    }}
                  />
                  ))
                }
                <StyledLeadContainer>
                <ReactQuill
                        ref={quillRef}
                        theme="snow" 
                        readOnly={disabled}
                        value={templateBodyValue} 
                        onChange={handleQuillChange} 
                        modules={isWhatsapp ? whatsappModules : modules}
                        formats={isWhatsapp ? whatsappFormats : formats}
                        style={{width: "100%", border: (!requiredError?.templateBody || templateBodyValue) ? "1px solid lightgray" : "1px solid red"}}
                    />
                    
                </StyledLeadContainer>
                </>
  )
}

export default TemplateBody